import { render } from "./index.vue?vue&type=template&id=6c04ee1e&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Others/Settings/ChangePassword/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c04ee1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c04ee1e', __exports__)) {
    api.reload('6c04ee1e', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=6c04ee1e&ts=true", () => {
    api.rerender('6c04ee1e', render)
  })

}


export default __exports__